<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header 
    [currentUser]="currentUser" 
    (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav 
      [isMobileMenuOpen]="isMobileMenuOpen"
      (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการรายการสอบ</h1>
          <p class="page-subtitle">ระบบจัดการรายการสอบประเมินผล</p>
        </div>

        <!-- Error Alert -->
        <ngb-alert 
          *ngIf="error" 
          type="danger" 
          [dismissible]="true"
          class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button 
              type="button" 
              class="clear-filters-btn" 
              (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>
          
          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.searchTerm" 
                (ngModelChange)="applyFilters()"
                placeholder="อีเมล, CID, ชื่อการสอบ">
            </div>

            <!-- Email -->
            <div class="filter-group">
              <label class="form-label">อีเมล</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.email" 
                (ngModelChange)="applyFilters()"
                placeholder="อีเมลผู้ใช้">
            </div>

            <!-- CID -->
            <div class="filter-group">
              <label class="form-label">เลขบัตรประชาชน</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.cid" 
                (ngModelChange)="applyFilters()"
                placeholder="เลขบัตรประชาชน">
            </div>

            <!-- Exam Title -->
            <div class="filter-group">
              <label class="form-label">ชื่อการสอบ</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.examTitle" 
                (ngModelChange)="applyFilters()"
                placeholder="ชื่อการสอบ">
            </div>

            <!-- Category -->
            <div class="filter-group">
              <label class="form-label">หมวดหมู่</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.category" 
                (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option value="Accounting">Accounting</option>
                <option value="Tax">Tax</option>
                <option value="Technology">Technology</option>
                <option value="Financial Reporting">Financial Reporting</option>
              </select>
            </div>

            <!-- Level -->
            <div class="filter-group">
              <label class="form-label">ระดับ</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.level" 
                (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option value="beginner">เริ่มต้น</option>
                <option value="intermediate">กลาง</option>
                <option value="advanced">สูง</option>
              </select>
            </div>

            <!-- Payment Status -->
            <div class="filter-group">
              <label class="form-label">สถานะการชำระเงิน</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.paymentStatus" 
                (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option value="รอชำระเงิน">รอชำระเงิน</option>
                <option value="รอตรวจสอบยอดชำระ">รอตรวจสอบยอดชำระ</option>
                <option value="ชำระเงินเสร็จสิ้น">ชำระเงินเสร็จสิ้น</option>
              </select>
            </div>

            <!-- Year Filter -->
            <div class="filter-group">
              <label class="form-label">ปี</label>
              <input 
                type="number" 
                class="form-control" 
                [(ngModel)]="filters.yearFilter" 
                (ngModelChange)="applyFilters()"
                placeholder="ปี พ.ศ."
                min="2500"
                max="2600">
            </div>

            <!-- Date From -->
            <div class="filter-group">
              <label class="form-label">วันที่สอบเริ่มต้น</label>
              <input 
                type="date" 
                class="form-control" 
                [(ngModel)]="filters.dateFrom" 
                (ngModelChange)="applyFilters()">
            </div>

            <!-- Date To -->
            <div class="filter-group">
              <label class="form-label">วันที่สอบสิ้นสุด</label>
              <input 
                type="date" 
                class="form-control" 
                [(ngModel)]="filters.dateTo" 
                (ngModelChange)="applyFilters()">
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-3">
            <button 
              type="button" 
              class="btn btn-outline-success" 
              (click)="exportToCSV()"
              [disabled]="isExporting || filteredRecords.length === 0">
              <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isExporting" class="bi bi-file-earmark-excel me-2"></i>
              {{ isExporting ? 'กำลัง Export...' : 'Export CSV' }}
            </button>
            <button 
              type="button" 
              class="btn btn-primary" 
              (click)="refreshData()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Status Tabs -->
        <div class="status-tabs mb-3" role="tablist" aria-label="สถานะใบคำขอสมัครสอบ">
          <button type="button" class="status-tab" *ngFor="let tab of statusTabs"
            [class.active]="isActiveStatusTab(tab)"
            [ngClass]="'status-tab-' + tab.color"
            role="tab" [attr.aria-selected]="isActiveStatusTab(tab)"
            (click)="selectStatusTab(tab)">
            <span class="status-tab-dot"></span>
            <span class="status-tab-name">{{ tab.name }}</span>
            <span class="status-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="exam-management-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลรายการสอบ...</p>
          </div>
        </div>

        <!-- Exam Lists Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการสอบทั้งหมด</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                  (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                  <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
                </select>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="sortable" (click)="sortBy('createdAt')"
                      [class.sorted]="isSortedBy('createdAt')" title="คลิกเพื่อเรียงลำดับ">
                      วันและเวลาที่ยื่นคำขอ {{ getSortIcon('createdAt') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('email')"
                      [class.sorted]="isSortedBy('email')" title="คลิกเพื่อเรียงลำดับ">
                      Email {{ getSortIcon('email') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('applicantName')"
                      [class.sorted]="isSortedBy('applicantName')" title="คลิกเพื่อเรียงลำดับ">
                      ชื่อ-นามสกุล {{ getSortIcon('applicantName') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('vatId')"
                      [class.sorted]="isSortedBy('vatId')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะสมาชิก (VAT ID) {{ getSortIcon('vatId') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('valuerId')"
                      [class.sorted]="isSortedBy('valuerId')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะผู้ประเมินหลัก (Valuer ID) {{ getSortIcon('valuerId') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('valuerRank')"
                      [class.sorted]="isSortedBy('valuerRank')" title="คลิกเพื่อเรียงลำดับ">
                      สอบชั้น {{ getSortIcon('valuerRank') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('year')"
                      [class.sorted]="isSortedBy('year')" title="คลิกเพื่อเรียงลำดับ">
                      ประจำปี {{ getSortIcon('year') }}
                    </th>
                    <th scope="col" class="text-center">คำขอ/เอกสารสมัครสอบ</th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('reviewStatus')"
                      [class.sorted]="isSortedBy('reviewStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการตรวจสอบเอกสาร {{ getSortIcon('reviewStatus') }}
                    </th>
                    <th scope="col" class="sortable text-end" (click)="sortBy('price')"
                      [class.sorted]="isSortedBy('price')" title="คลิกเพื่อเรียงลำดับ">
                      ราคา {{ getSortIcon('price') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentSlip')"
                      [class.sorted]="isSortedBy('paymentSlip')" title="คลิกเพื่อเรียงลำดับ">
                      หลักฐานการโอน {{ getSortIcon('paymentSlip') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentStatus')"
                      [class.sorted]="isSortedBy('paymentStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการชำระเงิน {{ getSortIcon('paymentStatus') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('receiptStatus')"
                      [class.sorted]="isSortedBy('receiptStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการออกใบเสร็จ {{ getSortIcon('receiptStatus') }}
                    </th>
                    <th scope="col">หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="!isLoading && getCurrentPageRecords().length === 0">
                    <td colspan="14" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-inbox"></i>
                        <p class="mb-0">ไม่พบข้อมูลรายการสอบ</p>
                        <small *ngIf="records.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small *ngIf="records.length > 0 && filteredRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                      </div>
                    </td>
                  </tr>

                  <!-- Record Rows -->
                  <tr *ngFor="let record of getCurrentPageRecords(); trackBy: trackByRecordId" class="clickable-row"
                    (click)="viewRecord(record)" title="คลิกเพื่อดูรายละเอียดคำขอสมัครสอบ">
                    <!-- วันและเวลาที่ยื่นคำขอ -->
                    <td>{{ formatDateTime(record.createdAt) }}</td>

                    <!-- Email -->
                    <td>{{ record.user.email }}</td>

                    <!-- ชื่อ-นามสกุล -->
                    <td>{{ getApplicantName(record) }}</td>

                    <!-- สถานะสมาชิก (VAT ID) -->
                    <td class="text-center"><span class="font-monospace">{{ getVatId(record) }}</span></td>

                    <!-- สถานะผู้ประเมินหลัก (Valuer ID) -->
                    <td class="text-center"><span class="font-monospace">{{ getValuerId(record) }}</span></td>

                    <!-- สอบชั้น -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getLevelBadgeClass(record.exam.valuerRank)">
                        {{ record.exam.valuerRank || '-' }}
                      </span>
                    </td>

                    <!-- ประจำปี -->
                    <td class="text-center">{{ record.year }}</td>

                    <!-- คำขอ/เอกสารสมัครสอบ (ตรวจสอบและอนุมัติในหน้าคำขอ) -->
                    <td class="text-center">
                      <button type="button" class="btn btn-sm btn-primary"
                        (click)="$event.stopPropagation(); viewRecord(record)"
                        title="เปิดดูคำขอและอนุมัติในหน้ารายละเอียด">
                        <i class="bi bi-search me-1"></i>ตรวจสอบคำขอ
                      </button>
                    </td>

                    <!-- สถานะการตรวจสอบเอกสาร -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getExamListStatusBadgeClass(record)">
                        {{ record.examListStatus.name }}
                      </span>
                    </td>

                    <!-- ราคา -->
                    <td class="text-end">{{ record.exam.examFee | number:'1.2-2' }} บาท</td>

                    <!-- หลักฐานการโอน -->
                    <td class="text-center">
                      <button *ngIf="hasPaymentSlip(record)" type="button" class="btn btn-sm btn-outline-primary"
                        (click)="openPaymentSlip(record, $event)" title="ดูหลักฐานการโอน">
                        <i class="bi bi-image"></i>
                      </button>
                      <span *ngIf="!hasPaymentSlip(record)" class="text-muted">-</span>
                    </td>

                    <!-- สถานะการชำระเงิน -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getExamPaymentStatusBadgeClass(record)">
                        {{ record.examListPaymentStatus.name }}
                      </span>
                    </td>

                    <!-- สถานะการออกใบเสร็จ -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getReceiptStatusClass(record)">
                        {{ getReceiptStatusText(record) }}
                      </span>
                    </td>

                    <!-- หมายเหตุ -->
                    <td>
                      <span [ngbTooltip]="record.notes || ''">
                        {{ record.notes ? (record.notes.length > 30 ? (record.notes.substring(0, 30) + '...') : record.notes) : '-' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }} 
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination 
                [(page)]="page" 
                [pageSize]="pageSize" 
                [collectionSize]="collectionSize"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                [size]="'sm'"
                (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
